<template>
  <div>
    <b-modal
      v-model="showUpdateRole"
      type="warn"
      title="Confirm Update"
      id="confirmSaveRoleModal"
      @ok="saveRole"
      ok-title="Yes, Save"
    >
      <p>Are you sure you want to save the changes made to this role?</p>
    </b-modal>
    <ValidationObserver v-slot="{ handleSubmit }">
      <form @submit.prevent="handleSubmit(showConfirmModal)">
        <div class="row">
          <div class="col-md-12">
            <div class="form-group">
              <label>Role*</label>
              <ValidationProvider mode="passive" rules="required" v-slot="{ errors }">
                <input type="text" v-model="roleName" class="form-control" ref="focusThis" />
                <span class="validate-error text-danger">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
          </div>
          <div class="col-md-12">
            <div class="form-group">
              <button class="btn btn-primary" type="submit" data-dismiss="modal">Save</button>
            </div>
          </div>
        </div>
      </form>
    </ValidationObserver>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  props: ["roleData"],
  data() {
    return {
      showUpdateRole: false,
      roleName: ''
    };
  },
  mounted() {
      this.roleName = this.roleData.name;
      this.$root.$on("bv::modal::show", (bvEvent, modalId) => {
			if (modalId == "confirmSaveRoleModal") {
                console.log($('#confirmSaveRoleModal'));
				$('#confirmSaveRoleModal footer button.btn-primary').focus();
			}
		});
  },
  methods: {
    showConfirmModal() {
      this.showUpdateRole = true;
    },
    focusMyElement() {
      this.$refs.focusThis.focus();
    },
    saveRole() {
      let that = this;
      this.showUpdateRole = false;
      this.$store.dispatch("updateRole", {name: this.roleName, id: this.roleData.id}).then(function(resp) {
          if(resp) {
            that.roleData.name = that.roleName;
            that.$bvModal.hide("editRoleModal");
          }
      });
    },
  },
};
</script>

<style>
</style>